module.exports = __webpack_public_path__ + "img/failed-message.c49f4951.svg";